import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { getPublicCurrentStates } from '../../../services/clientService';
import {
  currentStatesState,
  currentStateState,
  updateCurrentStatesState,
  updatedCurrentStateState,
} from '../../../storage/client';
import { loadingCurrentStatesState } from '../../../storage/currentStates';

function PublicClientProvider() {
  const setCurrentStates = useSetRecoilState(currentStatesState);
  const updatedCurrentState = useRecoilValue(updatedCurrentStateState);
  const setCurrentState = useSetRecoilState(currentStateState(updatedCurrentState ? updatedCurrentState.ident : ''));
  const setLoadingCurrentState = useSetRecoilState(loadingCurrentStatesState);
  const { shareLinkId } = useParams();
  const updateCurrentStates = useRecoilValue(updateCurrentStatesState);

  useEffect(() => {
    if (!shareLinkId) return;
    const loadCurrentState = async () => {
      setLoadingCurrentState(true);
      const { currentStates, error } = await getPublicCurrentStates(shareLinkId);
      if (!error && currentStates) {
        setCurrentStates(currentStates);
      } else {
        setCurrentStates(undefined);
      }
      setLoadingCurrentState(false);
    };
    loadCurrentState();
  }, [shareLinkId, updateCurrentStates, setCurrentStates, setLoadingCurrentState]);

  useUpdateEffect(() => {
    if (updatedCurrentState) {
      setCurrentState(updatedCurrentState);
      // TODO: Uncomment if needed on public tracking.
      // if (page === TRACKING_PAGE.id && assetId === updatedCurrentState.asset._id) {
      //   setAssetStates((prev) => {
      //     if (prev) {
      //       return [...prev, updatedCurrentState];
      //     }
      //     return [updatedCurrentState];
      //   });
      // }
    }
  }, [updatedCurrentState]);

  return null;
}

export default PublicClientProvider;
